<form #currentForm="ngForm" (submit)="submitForm(currentForm.form.valid)" novalidate>
  <fieldset>
    <div class="form-group">
      <label>Name</label>
      <input type="text" required [uniqueValidator]="'setting_groups' + (settingGroup.id ? '?id=' + settingGroup.id : '')" placeholder="Name" class="form-control" [(ngModel)]="settingGroup.name" name="name" #name="ngModel" />
      <div class="alert alert-danger alert-padding-sm" *ngIf="fieldShowErrorMessage(name)">{{ fieldBuildErrorMessage(name, 'Name') }}</div>
    </div>
    <div class="form-group">
      <button type="submit" [disabled]="formSubmitting" class="btn btn-primary">
        {{ settingGroup.id ? 'Save' : 'Add' }}
      </button>
      &nbsp;
      <button type="button" (click)="this.formEvent.emit('Form Cancelled')" class="btn btn-secondary">Cancel</button>
    </div>
  </fieldset>
</form>
